/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderQueryResult from './OrderQueryResult';

/**
 * The OrderOutputCmsOrder model module.
 * @module model/OrderOutputCmsOrder
 * @version 1.0
 */
class OrderOutputCmsOrder {
    /**
     * Constructs a new <code>OrderOutputCmsOrder</code>.
     * @alias module:model/OrderOutputCmsOrder
     */
    constructor() { 
        
        OrderOutputCmsOrder.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderOutputCmsOrder</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderOutputCmsOrder} obj Optional instance to populate.
     * @return {module:model/OrderOutputCmsOrder} The populated <code>OrderOutputCmsOrder</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderOutputCmsOrder();

            if (data.hasOwnProperty('order')) {
                obj['order'] = OrderQueryResult.constructFromObject(data['order']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/OrderQueryResult} order
 */
OrderOutputCmsOrder.prototype['order'] = undefined;






export default OrderOutputCmsOrder;

